import "core-js/modules/es.array.concat.js";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import Boss from "@tencent/vft-common/Boss";
import { getVuid } from '@tencent/vft-common/login';
var DEFAULT_BIZ_ID = 'film_front_error',
    FATAL = 5,
    ERROR = 4,
    WARNING = 3,
    INFO = 2,
    DEBUG = 1;

var extend = Object.assign || function (dest, source) {
  if (!source || _typeof(source) != 'object' || _typeof(dest) != 'object') {
    return dest;
  }

  for (var k in source) {
    dest[k] = source[k];
  }

  return dest;
};

var Monitor = /*#__PURE__*/function () {
  function Monitor(_ref) {
    var _ref$bizId = _ref.bizId,
        bizId = _ref$bizId === void 0 ? DEFAULT_BIZ_ID : _ref$bizId,
        pageId = _ref.pageId;

    _classCallCheck(this, Monitor);

    if (!pageId) {
      throw new Error('[@tencent/vft-monitor.Monitor.constructor]pageId is required');
    }

    this._boss = new Boss({
      bossId: 479,
      pwd: 0
    });
    this._bizId = bizId;
    this._pageId = pageId;
  }

  _createClass(Monitor, [{
    key: "_report",
    value: function _report(_ref2) {
      var sBiz = _ref2.sBiz,
          _ref2$modId = _ref2.modId,
          modId = _ref2$modId === void 0 ? 'default' : _ref2$modId,
          msg = _ref2.msg,
          file = _ref2.file,
          line = _ref2.line,
          fn = _ref2.fn,
          level = _ref2.level,
          code = _ref2.code,
          operate = _ref2.operate,
          _ref2$pname = _ref2.pname,
          pname = _ref2$pname === void 0 ? getVuid && getVuid() : _ref2$pname;

      if (!sBiz) {
        sBiz = "".concat(this._bizId, ".").concat(this._pageId, ".").concat(modId);
      }

      this._boss.report({
        sBiz: sBiz,
        errmsg: msg,
        srcfile: file,
        srcline: line,
        func: fn,
        level: level,
        iSta: code,
        sOp: operate,
        pname: pname
      });
    }
  }, {
    key: "fatal",
    value: function fatal(params) {
      this._report(extend(params, {
        level: FATAL
      }));
    }
  }, {
    key: "error",
    value: function error(params) {
      this._report(extend(params, {
        level: ERROR
      }));
    }
  }, {
    key: "warn",
    value: function warn(params) {
      this._report(extend(params, {
        level: WARNING
      }));
    }
  }, {
    key: "info",
    value: function info(params) {
      this._report(extend(params, {
        level: INFO
      }));
    }
  }, {
    key: "debug",
    value: function debug(params) {
      this._report(extend(params, {
        level: DEBUG
      }));
    }
  }], [{
    key: "getMonitor",
    value: function getMonitor(pageId) {
      var monitor = this.pool[pageId];

      if (!monitor) {
        this.pool[pageId] = monitor = new Monitor({
          bizId: DEFAULT_BIZ_ID,
          pageId: pageId
        });
      }

      return monitor;
    }
  }]);

  return Monitor;
}();

export { Monitor as default };
Monitor.pool = {};